import { createContext, useContext, useEffect, useState } from "react";
import QRCode from "qrcode";
import { BASE_URL } from "../config/apiConfig";

const QRContext = createContext();

export const useQR = () => useContext(QRContext);

export const QRProvider = ({ children }) => {
  const [qrCode, setQrCode] = useState("");
  const [loadingQR, setLoadingQR] = useState(false);
  const [autoRefresh, setAutoRefresh] = useState(false);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const token = localStorage.getItem("token");

  const authHeader = {
    Authorization: `Bearer ${token}`,
  };

  // ---------------------------------------
  // MAIN API → Fetch Token → Generate QR
  // ---------------------------------------
  const generateQR = async () => {
    try {
      setLoadingQR(true);

      if (!user?.id || !token) {
        console.error("User or token missing!");
        return;
      }

      const res = await fetch(`${BASE_URL}/qr/generate/${user.id}`, {
        headers: {
          ...authHeader,
          "Content-Type": "application/json",
        },
      });

      const data = await res.json();

      if (data?.token) {
        const qrImage = await QRCode.toDataURL(data.token);
        setQrCode(qrImage);
      }
    } catch (err) {
      console.error("QR Error:", err);
    } finally {
      setLoadingQR(false);
    }
  };

  // ---------------------------------------
  // AUTO REFRESH EVERY 2 MINUTES
  // ---------------------------------------
  useEffect(() => {
    if (!autoRefresh) return;

    generateQR(); // run immediately when enabled

    const interval = setInterval(() => {
      generateQR();
    }, 120000); // 2 minutes

    return () => clearInterval(interval); // cleanup on disable
  }, [autoRefresh]);

  return (
    <QRContext.Provider
      value={{
        qrCode,
        loadingQR,
        generateQR,
        autoRefresh,
        setAutoRefresh,
      }}
    >
      {children}
    </QRContext.Provider>
  );
};
